import { useMemo } from "react";
import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { roadCategoryMap } from "./constants";

export const useTrafficMetadata = (designationData: SingleDesignation) => {
  const roadName = useMemo(() => {
    return designationData.designation_attributes.find((attribute) => attribute.key === "road_name")?.value || "";
  }, [designationData]);

  const roadCategory = useMemo(() => {
    const rawRoadCat =
      (designationData.designation_attributes.find((attribute) => attribute.key === "road_category")
        ?.value as keyof typeof roadCategoryMap) || null;

    return roadCategoryMap[rawRoadCat] ?? "";
  }, [designationData]);

  const estimationMethod = useMemo(() => {
    return (
      designationData.designation_attributes.find((attribute) => attribute.key === "estimation_method")?.value || null
    );
  }, [designationData]);

  return {
    roadName,
    roadCategory,
    estimationMethod,
  };
};
